"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedParser = void 0;
const abstract_1 = require("./abstract");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class EmbedParser extends abstract_1.AbstractParser {
    /**
     * Parses the passed-in EmbedToken to HTML.
     *
     * @param src - EmbedToken to parse.
     *
     * @returns - HTML representation of the passed-in EmbedToken.
     */
    parse(src) {
        return '<section class="embed"></section>';
    }
}
exports.EmbedParser = EmbedParser;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1iZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcGFyc2Vycy9lbWJlZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsK0JBQStCOzs7QUFJL0IseUNBQTJDO0FBRTNDOztHQUVHO0FBQ0gsTUFBYSxXQUFZLFNBQVEseUJBQTBCO0lBQ3pEOzs7Ozs7T0FNRztJQUNJLEtBQUssQ0FBRSxHQUFlO1FBQzNCLE9BQU8sbUNBQW1DLENBQUE7SUFDNUMsQ0FBQztDQUNGO0FBWEQsa0NBV0MiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBDb3B5cmlnaHQgwqkgMjAyMSBNb3ZlIENsb3NlclxuXG5pbXBvcnQgeyBFbWJlZFRva2VuIH0gZnJvbSAnLi4vY29udHJhY3RzJ1xuXG5pbXBvcnQgeyBBYnN0cmFjdFBhcnNlciB9IGZyb20gJy4vYWJzdHJhY3QnXG5cbi8qKlxuICogQGF1dGhvciBTdGFuaXPFgmF3IEdyZWdvciA8c3RhbmlzbGF3LmdyZWdvckBtb3ZlY2xvc2VyLnBsPlxuICovXG5leHBvcnQgY2xhc3MgRW1iZWRQYXJzZXIgZXh0ZW5kcyBBYnN0cmFjdFBhcnNlcjxFbWJlZFRva2VuPiB7XG4gIC8qKlxuICAgKiBQYXJzZXMgdGhlIHBhc3NlZC1pbiBFbWJlZFRva2VuIHRvIEhUTUwuXG4gICAqXG4gICAqIEBwYXJhbSBzcmMgLSBFbWJlZFRva2VuIHRvIHBhcnNlLlxuICAgKlxuICAgKiBAcmV0dXJucyAtIEhUTUwgcmVwcmVzZW50YXRpb24gb2YgdGhlIHBhc3NlZC1pbiBFbWJlZFRva2VuLlxuICAgKi9cbiAgcHVibGljIHBhcnNlIChzcmM6IEVtYmVkVG9rZW4pOiBzdHJpbmcge1xuICAgIHJldHVybiAnPHNlY3Rpb24gY2xhc3M9XCJlbWJlZFwiPjwvc2VjdGlvbj4nXG4gIH1cbn1cbiJdfQ==